import React, { Suspense, useState } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import * as THREE from 'three';
import { EffectComposer, DepthOfField, Bloom } from "@react-three/postprocessing";
import { Html, Icosahedron, MeshDistortMaterial, useCubeTexture, GradientTexture, GradientType } from "@react-three/drei";

function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

function BackgroundIco(props) {
  // we use this array ref to store the icos after creating them
  const icoColors = ["#1c20ff", "#ff0059", "#66ff94"]
  const [colorState, setColorState] = useState(icoColors[getRandomInt(icoColors.length)])
  const [icoRef, setIcoRef] = useState()
  //create material ref
  const [material, set] = useState();
  const envMap = useCubeTexture(
    ["px.png", "nx.png", "py.png", "ny.png", "pz.png", "nz.png"],
    { path: "/cubeTextures/" })
  
  useFrame(() => {
    // animate each ico in the array
    icoRef.position.y += 0.02;
    if (icoRef.position.y > 19) {
      icoRef.position.y = -18;
      //change color at random
      setColorState(icoColors[getRandomInt(icoColors.length)])
    }
    icoRef.rotation.x += 0.06;
    icoRef.rotation.y += 0.06;
    icoRef.rotation.z += 0.02;
  });

  return (
    <>
      <MeshDistortMaterial
        ref={set}
        envMap={envMap}
        color={colorState}
        roughness={0.1}
        metalness={1}
        clearcoat={1}
        clearcoatRoughness={1}
        radius={1}
        distort={0.4}
      />
      <Icosahedron
        args={[1, 4]}
        position={props.position}
        material={material}
        ref={setIcoRef}
      />
    </>
  );
}

function BackgroundScene() {
  const initialPositions = [
    [-4, 20, -12],
    [-10, 12, -11],
    [-11, -12, -23],
    [-16, -6, -10],
    [12, -2, -13],
    [13, 4, -12],
    [14, -2, -23],
    [8, 10, -20],
    [5, -2, 0],
    [-2, 10, -6],
    [-9, 6, -5],
    [5, 2, -3],
    [-8, 4, -4],
    [6, -2, -5],
    [-2, 10, -1],
    [-8, -8, -12],
    [-12, 1, -6],
    [0, 3, -5],
    [7, 1, -3],
    [14, 5, 10],
    [0, -2, -2],
    [-1, -1, -3],
    [1, 9, -4],
    [2, 1, -8],
    [3, -11, -9],
    [-4, 3, -8]
    
  ];
  const [bgSphere, setBgSphere] = useState()
  useFrame(() => {
    bgSphere.rotation.x += 0.0008;
    bgSphere.rotation.y += 0.0008;
    bgSphere.rotation.z += 0.002;
  });

  return (
    <>      
      <mesh ref={setBgSphere}>
        <meshBasicMaterial side={THREE.DoubleSide}>
          <GradientTexture
            stops={[0, 0.25, 0.5, 0.75, 1]} // As many stops as you want
            colors={['#ff00d4', "#ae00ff", "#0099ff", '#00ff6e', '#00c8ff']} // Colors need to match the number of stops
            type={GradientType.Radial} // The type of the gradient, default = GradientType.Linear
            innerCircleRadius={0} // Optional, the radius of the inner circle of the gradient, default = 0
            outerCircleRadius={'auto'} // Optional, the radius of the outer circle of the gradient, default = auto
          />
        </meshBasicMaterial>
        <sphereGeometry args={[32, 32, 32]}/>
      </mesh>      
      {initialPositions.map((pos, i) => (
        <BackgroundIco position={pos}/>
      ))}
    </>
  );
}

export default function Lamp() {
  return (
    <Canvas
      colorManagement
      camera={{ position: [0, 0, 0] }}
      gl={{
        powerPreference: "high-performance",
        alpha: false,
        antialias: false,
        stencil: false,
        depth: false,
      }}
    >
      <color attach="background" args={["#1f1f1f"]} />
      <fog color="#161616" attach="fog" near={8} far={64} />
      <Suspense fallback={<Html center>Loading.</Html>}>
        <BackgroundScene />
      </Suspense>
      <EffectComposer multisampling={0} disableNormalPass={true}>
        <DepthOfField
          focusDistance={0}
          focalLength={0.02}
          bokehScale={2}
          height={480}
        />
        <Bloom
          luminanceThreshold={0}
          luminanceSmoothing={0.9}
          height={300}
          opacity={3}
        />
        {/* <Vignette eskil={false} offset={0.1} darkness={1.1} /> */}{/*Vignette is from postprocessing*/}
      </EffectComposer>
    </Canvas>
  );
}
